import { HelpRounded } from "@mui/icons-material";
import { useTheme } from "@mui/material";
import React from "react";

interface HelpSvgProps {
    width?: string;
    height?: string;
}

type Props = HelpSvgProps;

const SmartPredictSvg: React.FC<Props> = ({ width, height }) => {
    const theme = useTheme();

    return <HelpRounded fontSize="small" htmlColor={theme.palette.gray[400]} />;
};

export default SmartPredictSvg;
